// components
import Navbar from "./Components/Navbar";
import Intro from "./Components/Intro";
import Features from "./Components/Features";
import FindMore from "./Components/FindMore";
import Footer from "./Components/Footer";
import Copyright from "./Components/Copyright";
// provider
import { AppProvider } from "./context";

function App() {
	return (
		<div className="all">
			<AppProvider>
				<Navbar />
				<Intro />
				<Features />
				<FindMore />
				<Footer />
				<Copyright />
			</AppProvider>
		</div>
	);
}

export default App;
